import { axios as api } from './api';

const routePrefix = '/urls';

export const getFileUrl = async (
  fileId: number,
  partnerName?: string | null
): Promise<string> => {
  return api.get(
    `${routePrefix}/file/${fileId.toString()}?partnerName=${partnerName}`
  );
};
